import { Star } from "lucide-react";

// Floating proof card meant to overlap the corner of a hero photo —
// borrows the "review card on top of the image" pattern from premium
// firm sites to build instant trust without adding another section.
export const FloatingReviewCard = ({ name, quote, rating = 5, className = "" }) => (
  <div
    className={`rounded-2xl bg-white shadow-[0_24px_60px_rgba(11,18,32,0.28)] ring-1 ring-black/5 p-4 sm:p-5 max-w-[260px] ${className}`}
    data-testid="hero-floating-review-card"
  >
    <div className="flex items-center gap-1 mb-2">
      {Array.from({ length: rating }).map((_, i) => (
        <Star key={i} className="h-3.5 w-3.5 fill-[color:var(--gold-500)] text-[color:var(--gold-500)]" />
      ))}
    </div>
    <p className="text-xs sm:text-[13px] text-slate-700 leading-relaxed line-clamp-3">&ldquo;{quote}&rdquo;</p>
    <p className="mt-2 text-xs font-semibold text-[color:var(--navy-950)]">{name}</p>
  </div>
);
